import React from "react";
import { Flex, Select } from "antd";
import "./index.css";
import PropTypes from "prop-types";
const filterOption = (input, option) =>
  (String(option?.label) ?? "")
    .toLowerCase()
    .includes(String(input).toLowerCase());
const SingleSelectComponent = ({
  gap,
  isVertical,
  placeholder,
  options,
  onChange,
  onSearch,
  ...props
}) => {
  return (
    <Flex vertical={isVertical} gap={gap} className="antdSingleSelect">
      <Select
        {...props}
        showSearch
        allowClear
        placeholder={placeholder}
        optionFilterProp="children"
        onChange={onChange}
        onSearch={onSearch}
        filterOption={filterOption}
        options={options}
      />
    </Flex>
  );
};

SingleSelectComponent.propTypes = {
  gap: PropTypes.any,
  isVertical: PropTypes.bool,
  placeholder: PropTypes.string,
  options: PropTypes.any,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
};
export default SingleSelectComponent;
